var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyTillerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9904 5.76001C16.7525 5.76001 17.3704 5.14216 17.3704 4.38C17.3704 3.61785 16.7525 3 15.9904 3C15.2282 3 14.6104 3.61785 14.6104 4.38C14.6104 5.14216 15.2282 5.76001 15.9904 5.76001Z",
    fill: "#F06617"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91907 11.5738C6.68122 11.5738 7.29907 10.956 7.29907 10.1938C7.29907 9.43169 6.68122 8.81384 5.91907 8.81384C5.15691 8.81384 4.53906 9.43169 4.53906 10.1938C4.53906 10.956 5.15691 11.5738 5.91907 11.5738Z",
    fill: "#F06617"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91907 23.2014C6.68122 23.2014 7.29907 22.5836 7.29907 21.8214C7.29907 21.0593 6.68122 20.4414 5.91907 20.4414C5.15691 20.4414 4.53906 21.0593 4.53906 21.8214C4.53906 22.5836 5.15691 23.2014 5.91907 23.2014Z",
    fill: "#F06617"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9904 29C16.7525 29 17.3704 28.3822 17.3704 27.62C17.3704 26.8578 16.7525 26.24 15.9904 26.24C15.2282 26.24 14.6104 26.8578 14.6104 27.62C14.6104 28.3822 15.2282 29 15.9904 29Z",
    fill: "#F06617"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.047 23.2014C26.8091 23.2014 27.427 22.5836 27.427 21.8214C27.427 21.0593 26.8091 20.4414 26.047 20.4414C25.2848 20.4414 24.667 21.0593 24.667 21.8214C24.667 22.5836 25.2848 23.2014 26.047 23.2014Z",
    fill: "#F06617"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.047 11.5738C26.8091 11.5738 27.427 10.956 27.427 10.1938C27.427 9.43169 26.8091 8.81384 26.047 8.81384C25.2848 8.81384 24.667 9.43169 24.667 10.1938C24.667 10.956 25.2848 11.5738 26.047 11.5738Z",
    fill: "#F06617"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9904 18.3116C17.2634 18.3116 18.2953 17.2796 18.2953 16.0067C18.2953 14.7337 17.2634 13.7018 15.9904 13.7018C14.7175 13.7018 13.6855 14.7337 13.6855 16.0067C13.6855 17.2796 14.7175 18.3116 15.9904 18.3116Z",
    fill: "#F06617"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.76 18.3116C23.0329 18.3116 24.0649 17.2796 24.0649 16.0067C24.0649 14.7337 23.0329 13.7018 21.76 13.7018C20.487 13.7018 19.4551 14.7337 19.4551 16.0067C19.4551 17.2796 20.487 18.3116 21.76 18.3116Z",
    fill: "#F06617"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2209 18.3116C11.4939 18.3116 12.5258 17.2796 12.5258 16.0067C12.5258 14.7337 11.4939 13.7018 10.2209 13.7018C8.94795 13.7018 7.91602 14.7337 7.91602 16.0067C7.91602 17.2796 8.94795 18.3116 10.2209 18.3116Z",
    fill: "#F06617"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9904 12.5423C17.2634 12.5423 18.2953 11.5104 18.2953 10.2374C18.2953 8.96443 17.2634 7.9325 15.9904 7.9325C14.7175 7.9325 13.6855 8.96443 13.6855 10.2374C13.6855 11.5104 14.7175 12.5423 15.9904 12.5423Z",
    fill: "#F06617"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9904 24.081C17.2634 24.081 18.2953 23.0491 18.2953 21.7761C18.2953 20.5031 17.2634 19.4712 15.9904 19.4712C14.7175 19.4712 13.6855 20.5031 13.6855 21.7761C13.6855 23.0491 14.7175 24.081 15.9904 24.081Z",
    fill: "#F06617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyTillerIcon);
export default __webpack_public_path__ + "static/media/verify-tiller-icon.11a20bf7a1fbb9bb7c06b371142d3d4c.svg";
export { ForwardRef as ReactComponent };